import React, { useMemo } from 'react';
import './advstats.css';

const AdvStats1 = ({ orders }) => {
    const monthlyStats = useMemo(() => {
        const stats = {};
        const financialStatusSet = new Set(); // Track unique financial statuses
        
        orders.forEach(order => {
            if (order.financial_status === "voided") return;

            const date = new Date(order.created_at);
            const monthKey = `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, '0')}`;
            
            // Get financial status
            const financialStatus = order.financial_status || 'undefined';
            financialStatusSet.add(financialStatus);
            
            if (!stats[monthKey]) {
                stats[monthKey] = {
                    totalSales: 0,
                    cardOrders: 0,
                    totalOrders: 0,
                    pendingCOD: 0,
                    financialStatusAmounts: {} // Track amounts per financial status
                };
            }

            // Initialize financial status amount if not exists
            if (!stats[monthKey].financialStatusAmounts[financialStatus]) {
                stats[monthKey].financialStatusAmounts[financialStatus] = 0;
            }
            
            const amount = parseFloat(order.current_total_price || order.total_price || 0);
            stats[monthKey].totalSales += amount;
            stats[monthKey].totalOrders += 1;
            stats[monthKey].financialStatusAmounts[financialStatus] += amount;

            // Check shipping method to determine payment type
            const shippingMethod = order.shipping_lines?.[0]?.code || '';
            const isCardPayment = shippingMethod.includes('Plata CARD');
            
            if (isCardPayment) {
                stats[monthKey].cardOrders += 1;
            } else if (shippingMethod === 'Livrare Express si Plata la Livrare' && 
                      order.financial_status === 'pending') {
                stats[monthKey].pendingCOD += amount;
            }
        });

        return { 
            stats, 
            financialStatusList: Array.from(financialStatusSet).sort() 
        };
    }, [orders]);

    // Get sorted months for table headers
    const sortedMonths = Object.keys(monthlyStats.stats).sort();

    const formatNumber = (num) => {
        return num.toLocaleString('en-US', {
            minimumFractionDigits: 0,
            maximumFractionDigits: 0
        });
    };

    const formatPercentage = (value, total) => {
        if (!total) return '0.00%';
        return `${((value / total) * 100).toFixed(2)}%`;
    };

    return (
        <div className="adv-stats-container">
            <div className="table-scroll">
                <table className="monthly-stats-table">
                    <thead>
                        <tr>
                            <th>Metric</th>
                            {sortedMonths.map(month => {
                                const [year, monthNum] = month.split('-');
                                return (
                                    <th key={month}>
                                        {monthNum}/{year}
                                    </th>
                                );
                            })}
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td>Total Sales (RON)</td>
                            {sortedMonths.map(month => (
                                <td key={`sales-${month}`}>
                                    {formatNumber(monthlyStats.stats[month].totalSales)}
                                </td>
                            ))}
                        </tr>
                        <tr>
                            <td>% Card Payments</td>
                            {sortedMonths.map(month => (
                                <td key={`card-${month}`}>
                                    {formatPercentage(monthlyStats.stats[month].cardOrders, monthlyStats.stats[month].totalOrders)}
                                </td>
                            ))}
                        </tr>
                        <tr>
                            <td>Pending COD (RON)</td>
                            {sortedMonths.map(month => (
                                <td key={`pending-cod-${month}`}>
                                    {formatNumber(monthlyStats.stats[month].pendingCOD)}
                                </td>
                            ))}
                        </tr>
                        {monthlyStats.financialStatusList.map(status => (
                            <tr key={`financial-status-${status}`}>
                                <td>Financial: {status}</td>
                                {sortedMonths.map(month => (
                                    <td key={`${status}-${month}`}>
                                        {formatNumber(monthlyStats.stats[month].financialStatusAmounts[status] || 0)}
                                    </td>
                                ))}
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>
        </div>
    );
};

export default AdvStats1; 